export default __webpack_public_path__ + "2023 Modification of ground-state chemical reactivity via light–matter coherence in infrared cavities.pdf";